import TableCellRenderer from '../../../../table/TableCellRenderer'
import _ from 'underscore'

function PlannedLeaveRenderer() {}

PlannedLeaveRenderer.prototype = _.create(TableCellRenderer.prototype);

PlannedLeaveRenderer.prototype.init = function(formatter) {
    TableCellRenderer.call(this);
    this.formatter = formatter;
    return this;
};

PlannedLeaveRenderer.prototype.hasValue = function(cell) {
    return false;
};

PlannedLeaveRenderer.prototype.getCellClassName = function(cell) {
    var value = cell.getValue();
    return [this.cellGeneralClassName, 'plannedLeaveCell', this.hasValue(cell) ? "on" : "off"];
};

PlannedLeaveRenderer.prototype.generateContent = function(cell) {
    //abstract
};

function PlannedPTOLeaveRenderer() {}

PlannedPTOLeaveRenderer.prototype = _.create(PlannedLeaveRenderer.prototype);
PlannedPTOLeaveRenderer.prototype.cellGeneralClassName = "ptoCell";
PlannedPTOLeaveRenderer.prototype.hasValue = function(cell) {
    return cell.getValue().pto;
};
PlannedPTOLeaveRenderer.prototype.generateContent = function(cell) {
    var value = cell.getValue();
    cell.getCellEl().innerHTML = !this.hasValue(cell) ? "&ndash;" : this.formatter(value.currentPTOBalance.plannedBalanceApproved);
};

function PlannedSickLeaveRenderer() {}

PlannedSickLeaveRenderer.prototype = _.create(PlannedLeaveRenderer.prototype);
PlannedSickLeaveRenderer.prototype.cellGeneralClassName = "sickDaysCell";
PlannedSickLeaveRenderer.prototype.hasValue = function(cell) {
    return cell.getValue().sick;
};
PlannedSickLeaveRenderer.prototype.generateContent = function(cell) {
    var value = cell.getValue();
    cell.getCellEl().innerHTML = !this.hasValue(cell) ? "&ndash;" : this.formatter(value.currentSickDaysBalance.plannedBalanceApproved);
};


export default PlannedLeaveRenderer
export {
    PlannedPTOLeaveRenderer,
    PlannedSickLeaveRenderer
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PlannedLeaveRenderer.js